export const ListOfEventAchiever = {
    "2025UPCOMING": "2025 Upcoming APCS Festival",
    "2024APCSCLASSIC": "2024 Classical Festival Jakarta",
    "2023CHRISTMAS": "2023 Christmas Wonderland",
    "2023CLASSICJKT": "2023 Classical Festival Jakarta",
    "2023CLASSICSRBY": "2023 Classical Festival Surabaya",
    "2022MAGICMUSIC": "2022 Magical Music Soundtrack",
}